export const CONTACT_I18N_ENTRIES = {
  contact_Data1: {
    es: '<p><span>Déjanos</span> tus datos y nuestro equipo se pondrá en <span>contacto</span> contigo</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data2: {
    es: '<p><span>Garantiza</span> el camino hacia una gestión más <span>eficiente</span> y <span>segura</span> del mantenimiento de carreteras</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data3: {
    es: '<p>Rellena el formulario</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data4: {
    es: '<p>Nombre*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data5: {
    es: '<p>Correo electrónico*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data6: {
    es: '<p>Nº de teléfono</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data7: {
    es: '<p>País</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data8: {
    es: '<p>Escribe tu consulta...</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data9: {
    es: '<p>He leído y acepto las</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data10: {
    es: '<p>condiciones de uso.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data11: {
    es: '<p>Acepto recibir comunicaciones comerciales relacionadas con la entidad <span>eyesNroad</span> a través de correo electrónico.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data12: {
    es: '<p>Enviar consulta</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data13: {
    es: '<p>Rellena el campo correctamente</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  contact_Data14: {
    es: '<p>Gracias por completar el formulario. Nos pondremos en contacto contigo lo antes posible.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
